import { ROUTE_ACCESS } from './route-access.js';
/** The route's own entry plus every ancestor entry, outermost first. */
export function accessRouteChain(route) {
    const segments = route.split('/');
    const chain = [];
    for (let length = 2; length <= segments.length; length += 1) {
        const prefix = segments.slice(0, length).join('/');
        if (Object.hasOwn(ROUTE_ACCESS, prefix))
            chain.push(ROUTE_ACCESS[prefix]);
    }
    return chain;
}
//# sourceMappingURL=access-route-chain.js.map